import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout/layout.component';

// Componentes esenciales
import { RegisterComponent } from './register/register.component';
import { PasswordForgetComponent } from './password-forget/password-forget.component';

// Páginas principales
import { CumplimientoLeyComponent } from './pages/cumplimiento-ley/cumplimiento-ley.component';
import { ServiciosEmpresasComponent } from './pages/servicios-empresas/servicios-empresas.component';
import { ParaCandidatosComponent } from './pages/para-candidatos/para-candidatos.component';
import { ComoTrabajamosComponent } from './pages/como-trabajamos/como-trabajamos.component';
import { OportunidadesComponent } from './pages/oportunidades/oportunidades.component';
import { ContactoComponent } from './pages/contacto/contacto.component';
import { NosotrosComponent } from './pages/nosotros/nosotros.component';

const routes: Routes = [
  {
    path: '', component: LayoutComponent,
    children: [
      { 
        path: '', 
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule) 
      },
      { path: 'nosotros', component: NosotrosComponent },
      { path: 'servicios', component: ServiciosEmpresasComponent },
      { path: 'para-candidatos', component: ParaCandidatosComponent },
      { path: 'como-trabajamos', component: ComoTrabajamosComponent },
      { path: 'oportunidades', component: OportunidadesComponent },
      { path: 'cumplimiento-ley', component: CumplimientoLeyComponent },
      { path: 'contacto', component: ContactoComponent }
    ]
  },
  { path: 'register', component: RegisterComponent },
  { path: 'password-forget', component: PasswordForgetComponent },
  { path: '**', redirectTo: '/', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, enableTracing: false })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }